<template>
    <b-card no-body>
        <div class="card-title">
            {{ $t('Component(Text):information-requested') }}
        </div>
        <div class="pb-2">
            <CoveredLegislations :legislations="request.legislations" />
        </div>
        <div class="pb-2">
            <VerificationDocuments
                :evidence-report-types="request.evidenceReportTypes"
                :verification-documents="request.verificationDocuments"
            />
        </div>
        <div class="pb-2">
            <InformationLevel :information-level="request.informationLevel" />
        </div>
        <div>
            <h6>{{ $t('Component(Label):last-response-date') }}</h6>
            <span>{{ renderDate(request.validTo) }}</span>
        </div>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import VerificationDocuments from "@/views/request/components/VerificationDocuments";
import CoveredLegislations from "@/views/request/components/CoveredLegislations";
import InformationLevel from "@/views/request/components/InformationLevel";
import dateRenderer from "@core/mixins/date-renderer";

export default {
    mixins: [dateRenderer],
    components: {
        BCard, VerificationDocuments, CoveredLegislations, InformationLevel,
    },
    props: {
        request: {
            type: Object,
            default() {
                return {
                    legislations: [],
                    verificationDocuments: [],
                    informationLevel: []
                };
            }
        }
    }
}
</script>
